import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers"
import CategoryHero from "../ones/CategoryHero"
import Footer from "../ones/Footer"
import OneVideo from "../ones/OneVideo"

export default function VideosLanding() {

  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    await Promise.all([
      appContext.getAllVideos(),
    ])
    setReady(true);
  }

  useEffect(() => {
    init();
  }, [])

  if (ready) {
    const records = appContext.allVideos || [];

    return (
      <>
        <CategoryHero
          eyebrow="MIKA KENYATA VIDEOS"
          title="Watch ideas come to life."
          description="Browse published video content available in the marketplace."
        />

        <div className="container marketplace-page-container">
          <h6 className="main-section-title">Videos</h6>
          <div className="row g-4">
            {
              records.length > 0 ?
                records.map((item) => {
                  return (
                    <div className="col-12 col-sm-6 col-lg-4" key={item.uuid}>
                      <OneVideo data={item} />
                    </div>
                  )
                })
                :
                <div className="col-12">
                  <div className="marketplace-empty-state">No videos were found</div>
                </div>
            }
          </div>
        </div>

        <Footer />
      </>
    )
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}
